export enum Sex {
  Male = 1,
  Female = 2,
}
